export default __webpack_public_path__ + "static/media/business-03.63f76981.jpg";